/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import styled from 'styled-components';

interface PreviewProps {
    fontSize?: string;
}

export const IconPreview = styled.i<{ fontSize: string }>`
    font-size: ${({ fontSize }) => fontSize};
`;

export const ImagePreview = styled.img`
    max-height: 258px;
    width: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
`;

export const PreviewContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export const PDFPreview = ({ fontSize = '75px' }: PreviewProps) => {
    return <IconPreview fontSize={fontSize} className='fa fa-file-pdf-o' />;
};
export const NotFoundPreview = ({ fontSize = '75px' }: PreviewProps) => {
    return <IconPreview fontSize={fontSize} className='fa fa-ban' />;
};

export const OtherPreview = ({ fontSize = '75px' }: PreviewProps) => {
    return <IconPreview fontSize={fontSize} className='fa fa-camera' />;
};
